import React, { useState, useRef, useEffect } from "react";
import axiosInstance from '../axiosInstance';
import {
  Box,
  Button,
  CircularProgress,
  LinearProgress,
  Typography,
  TextField,
  Snackbar,
  Alert,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Paper,
  Checkbox,
  FormControlLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
  Link
} from "@mui/material";
import { useSelector } from "react-redux";
import { 
  Upload as UploadIcon, 
  Close as CloseIcon,
  ExpandMore as ExpandMoreIcon,
  Security as SecurityIcon,
  CloudUpload as CloudUploadIcon,
  Storage as StorageIcon,
  LockClock as LockClockIcon
} from "@mui/icons-material";
import moment from "moment-timezone";

export default function TaxAgent() {
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [checkingConsent, setCheckingConsent] = useState(true);
  const [agreeChecked, setAgreeChecked] = useState(false);
  const [privacyLoading, setPrivacyLoading] = useState(false);
  const [privacyError, setPrivacyError] = useState("");
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [jsonUrl, setJsonUrl] = useState(null);
  const [showExcel, setShowExcel] = useState(false);
  const [instructions, setInstructions] = useState("");
  const [aisPassword, setAisPassword] = useState("");
  const [error, setError] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [iframeKey, setIframeKey] = useState(Date.now());
  const [currentTimezone, setCurrentTimezone] = useState(
      Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC"
    );

  const fileInputRef = useRef(null);
  const account = useSelector(state => state?.account);
  const fileId = account?.user?.tax_agent_excel_name;
  const taxAgentExcelUrl = account?.user?.tax_agent_excel_url;
  
  console.log("account state:", account);
  console.log("tax_agent_excel_name:", fileId);

  const userId = useSelector(
    (state) => state?.account?.user_id || state?.account?.org_member?.id
  );
  const orgId = useSelector(
    (s) => s?.account?.org?.id || s?.account?.org_data?.data?.id
  );

  const baseSharepointUrl =taxAgentExcelUrl
    ? taxAgentExcelUrl +
    "?e=Tcj9cM&action=embedview&AllowTyping=True&wdDownloadButton=True&wdInConfigurator=True&wdHideHeaders=True" : null;

    // Check privacy consent
    useEffect(() => {
      const checkPrivacyConsent = async () => {
        if (!userId) {
          setCheckingConsent(false);
          return;
        }
        try {
          const response = await axiosInstance.post(
            //"http://localhost:8000/tax_agent/has_accepted_privacy_consent",
            "https://api.projectivetech.com/tax_agent/has_accepted_privacy_consent",
            {
              user_id: userId,
              module: "tax_agent"
            },
            {
              headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCookie('csrftoken') || ''
              }
            }
          );
          if (response.data.accepted) {
            setPrivacyAccepted(true);
          }
        } catch (error) {
          console.error("Error checking privacy consent:", error);
        } finally {
          setCheckingConsent(false);
        }
      };
      checkPrivacyConsent();
    }, [userId]);
  
    // Accept privacy
    const handleAcceptPrivacy = async () => {
      if (!agreeChecked) return;
      setPrivacyLoading(true);
      setPrivacyError("");
  
      try {
        const payload = {
          module: "tax_agent",
          org_id: orgId ? String(orgId) : "",
          user_id: userId ? String(userId) : "",
          timezone: currentTimezone
        };
  
        const response = await axiosInstance.post(
          //"http://localhost:8000/tax_agent/accept_privacy_consent",
          "https://api.projectivetech.com/tax_agent/accept_privacy_consent",
          
          payload,
          {
            withCredentials: true,
            headers: {
              'Content-Type': 'application/json',
              'X-CSRFToken': getCookie('csrftoken') || ''
            }
          }
        );
  
        if (response.data.status === 'ok') {
          setPrivacyAccepted(true);
        } else {
          throw new Error(response.data.error || 'Unknown error');
        }
      } catch (err) {
        setPrivacyError(
          err.response?.data?.error ||
          err.message ||
          'Failed to accept privacy policy.'
        );
      } finally {
        setPrivacyLoading(false);
      }
    };
    
    const handleHitlReconciliation = async () => {
      try {
        setLoading(true);
        setStatusMessage("Performing HITL Reconciliation...");
        const formData = new FormData();
        formData.append("fileId", fileId);
        formData.append("orgId", orgId);      // optional, if needed in backend
        formData.append("userId", userId); 
        // Call your backend API for HITL reconciliation
        //const response = await axiosInstance.post("http://localhost:8000/tax_agent/reprocess_reconciliation_sheet",{
        const response = await axiosInstance.post("http://ec2-13-127-114-103.ap-south-1.compute.amazonaws.com:8001/tax_agent/reprocess_reconciliation_sheet",{
         
          fileId,
          orgId,
          userId
        });

        if (response.status === 200 || response.data.status === "success") {
          setStatusMessage("HITL Reconciliation completed successfully!");
          setSnackbarOpen(true);
        } else {
          throw new Error(response.data.error || "Error in HITL reconciliation.");
        }
      } catch (err) {
        setStatusMessage("Error in HITL Reconciliation.");
        console.error(err);
        setSnackbarOpen(true);
      } finally {
        setLoading(false);
      }
    };
    const handleHitlSecondLayerReconciliation = async () => {
      try {
        setLoading(true);
        setStatusMessage("Performing HITL Second Layer Reconciliation...");
        
        const formData = new FormData();
        formData.append("fileId", fileId);
        formData.append("orgId", orgId);      // optional, if needed in backend
        formData.append("userId", userId); 
        // Call your backend API for HITL second layer reconciliation
        const response = await axiosInstance.post("https://api.projectivetech.com:8001/tax_agent/hitl_second_layer_reconciliation", 
        //const response = await axiosInstance.post("http://localhost:8000/tax_agent/hitl_second_layer_reconciliation", 
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.status === 200 || response.data.status === "success") {
          setStatusMessage("HITL Second Layer Reconciliation completed successfully!");
          setSnackbarOpen(true);
        } else {
          throw new Error(response.data.error || "Error in HITL second layer reconciliation.");
        }
      } catch (err) {
        setStatusMessage("Error in HITL second layer reconciliation.");
        console.error(err);
        setSnackbarOpen(true);
      } finally {
        setLoading(false);
      }
    };

    function getCookie(name) {
      let cookieValue = null;
      if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i].trim();
          if (cookie.substring(0, name.length + 1) === (name + '=')) {
            cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
            break;
          }
        }
      }
      return cookieValue;
    }
  
    // ─── Conditional Renders ────────────────────────────────────────────────
  
    if (checkingConsent) {
      return (
        <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
          <CircularProgress />
          <Typography sx={{ ml: 2 }}>Loading Tax Agent…</Typography>
        </Box>
      );
    }
  
    if (!privacyAccepted) {
      return (
        
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          p={2}
          height="100vh"
          bgcolor="#fafafa"
        >
          <Paper elevation={3} sx={{ 
            maxWidth: 800, 
            width: "100%", 
            maxHeight: "80vh", 
            p: 3, 
            overflowY: "auto", 
            mb: 2,
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
          }}>
            <Typography variant="h4" sx={{ 
              fontWeight: 700, 
              mb: 2,
              color: '#2e3b4e'
            }}>
              Tax Agent Privacy Policy
            </Typography>
            
            <Typography variant="subtitle1" sx={{ 
              mb: 3,
              color: '#555'
            }}>
              Effective Immediately | Last Updated: [Insert Date]
            </Typography>
            
            <Paper elevation={0} sx={{
              p: 3,
              mb: 4,
              backgroundColor: '#f8f9fa',
              borderLeft: '4px solid #3f51b5'
            }}>
              <Typography variant="body1">
                This policy explains how the Tax Agent module ("Service") within IMAGE-I platform processes your financial documents. 
                While we are not a SEBI-regulated entity, we voluntarily adhere to data security and privacy practices commonly followed by SEBI-regulated financial service providers.
              </Typography>
            </Paper>
            
            <Divider sx={{ my: 3 }} />
            
            {/* Data Collection Section */}
            <Accordion defaultExpanded elevation={0} sx={{ mb: 2 }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <CloudUploadIcon sx={{ mr: 1, color: '#3f51b5' }} />
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>1. Documents We Process</Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body1" paragraph>
                  When you use the Tax Agent service, we temporarily process:
                </Typography>
                
                <List dense sx={{ 
                  pl: 2,
                  '& li': {
                    display: 'list-item',
                    listStyleType: 'disc',
                    py: 0.5
                  }
                }}>
                  <ListItem sx={{ p: 0 }}>
                    <Typography variant="body1">Bank statements (Excel/CSV format)</Typography>
                  </ListItem>
                  <ListItem sx={{ p: 0 }}>
                    <Typography variant="body1">Tax documents (Form 16, 26AS, AIS in PDF)</Typography>
                  </ListItem>
                  <ListItem sx={{ p: 0 }}>
                    <Typography variant="body1">Business financial statements (Profit & Loss reports, if applicable)</Typography>
                  </ListItem>
                  <ListItem sx={{ p: 0 }}>
                    <Typography variant="body1">Capital gains reports from brokers</Typography>
                  </ListItem>
                </List>
                
                <Typography variant="body2" sx={{ 
                  mt: 2,
                  fontStyle: 'italic',
                  color: '#666'
                }}>
                  Note: All documents are processed in-memory and never stored permanently.
                </Typography>
              </AccordionDetails>
            </Accordion>
            
            {/* Data Processing Section */}
            <Accordion elevation={0} sx={{ mb: 2 }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <StorageIcon sx={{ mr: 1, color: '#3f51b5' }} />
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>2. Processing Methodology</Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body1" paragraph>
                  Your documents undergo this secure processing pipeline:
                </Typography>
                
                <Box component="ol" sx={{
                  pl: 2,
                  counterReset: 'step-counter',
                  '& li': {
                    position: 'relative',
                    pl: 3,
                    mb: 2,
                    '&:before': {
                      content: 'counter(step-counter) "."',
                      counterIncrement: 'step-counter',
                      position: 'absolute',
                      left: 0,
                      fontWeight: 'bold',
                      color: '#3f51b5'
                    }
                  }
                }}>
                  <ListItem sx={{ p: 0 }}>
                    <Typography variant="body1">
                      <strong>Document extraction</strong> using AWS Textract/pdfplumber used for structured extraction. Military-grade encryption (AES-256 in transit and at rest)
                    </Typography>
                  </ListItem>
                  <ListItem sx={{ p: 0 }}>
                    <Typography variant="body1">
                      <strong>Temporary conversion</strong> to text within isolated EC2 environments
                    </Typography>
                  </ListItem>
                  <ListItem sx={{ p: 0 }}>
                    <Typography variant="body1">
                      <strong>AI analysis</strong> via OpenAI's GPT API model with enterprise data protection. Analysis restricted to your session only
                    </Typography>
                  </ListItem>
                  <ListItem sx={{ p: 0 }}>
                    <Typography variant="body1">
                      <strong>Output generation</strong> to transient Excel files. these are **ephemeral** and not retained after the session ends, Are **overwritten** if a new submission is made, Are **auto-deleted** after a short period, Are not versioned or archived
                    </Typography>
                  </ListItem>
                </Box>
                
                <Typography variant="body1" sx={{ mt: 2 }}>
                  <strong>Key Assurance:</strong> No human reviews your documents at any stage.
                </Typography>
              </AccordionDetails>
            </Accordion>
            
            {/* Data Retention Section */}
            <Accordion elevation={0} sx={{ mb: 2 }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <LockClockIcon sx={{ mr: 1, color: '#3f51b5' }} />
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>3. Zero Retention Policy</Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body1" paragraph>
                  We implement strict financial-grade data hygiene:
                </Typography>
                
                <Box sx={{
                  backgroundColor: '#f5f7ff',
                  p: 2,
                  borderRadius: 1,
                  border: '1px solid #e0e0e0'
                }}>
                  <List dense>
                    <ListItem sx={{ alignItems: 'flex-start' }}>
                      <Box sx={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        backgroundColor: '#3f51b5',
                        mt: '8px',
                        mr: 2
                      }} />
                      <ListItemText 
                        primary="Original documents deleted immediately after processing" 
                        secondary="No archival of source files" 
                      />
                    </ListItem>
                    <ListItem sx={{ alignItems: 'flex-start' }}>
                      <Box sx={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        backgroundColor: '#3f51b5',
                        mt: '8px',
                        mr: 2
                      }} />
                      <ListItemText 
                        primary="AI outputs purged after each session" 
                        secondary="No training data or embeddings retained" 
                      />
                    </ListItem>
                    <ListItem sx={{ alignItems: 'flex-start' }}>
                      <Box sx={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        backgroundColor: '#3f51b5',
                        mt: '8px',
                        mr: 2
                      }} />
                      <ListItemText 
                        primary="Excel reports overwritten with new uploads" 
                        secondary="No version history maintained" 
                      />
                    </ListItem>
                  </List>
                </Box>
              </AccordionDetails>
            </Accordion>
            
            {/* Security Measures */}
            <Accordion elevation={0}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <SecurityIcon sx={{ mr: 1, color: '#3f51b5' }} />
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>4. Security Protocols</Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body1" paragraph>
                  We implement bank-level security measures:
                </Typography>
                
                <Box sx={{
                  display: 'grid',
                  gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                  gap: 2,
                  mt: 2
                }}>
                  <Paper elevation={0} sx={{ 
                    p: 2,
                    border: '1px solid #e0e0e0',
                    borderRadius: 1
                  }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>Infrastructure</Typography>
                    <List dense>
                      <ListItem sx={{ px: 0, py: 0.5 }}>
                        <ListItemText primary="• Isolated AWS EC2 instances per session" />
                      </ListItem>
                      <ListItem sx={{ px: 0, py: 0.5 }}>
                        <ListItemText primary="• VPC flow logging enabled" />
                      </ListItem>
                      <ListItem sx={{ px: 0, py: 0.5 }}>
                        <ListItemText primary="• Quarterly penetration testing" />
                      </ListItem>
                    </List>
                  </Paper>
                  
                  <Paper elevation={0} sx={{ 
                    p: 2,
                    border: '1px solid #e0e0e0',
                    borderRadius: 1
                  }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>Data Protection</Typography>
                    <List dense>
                      <ListItem sx={{ px: 0, py: 0.5 }}>
                        <ListItemText primary="• AES-256 encryption at rest" />
                      </ListItem>
                      <ListItem sx={{ px: 0, py: 0.5 }}>
                        <ListItemText primary="• TLS 1.3 for all transmissions" />
                      </ListItem>
                      <ListItem sx={{ px: 0, py: 0.5 }}>
                        <ListItemText primary="• Automatic 7-day purge cycles" />
                      </ListItem>
                    </List>
                  </Paper>
                </Box>
                
                <Typography variant="body1" sx={{ mt: 3 }}>
                  <strong>Third-party Services:</strong> We only use OpenAI's enterprise API which complies with SOC 2 Type II and GDPR standards.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion elevation={0} sx={{ mt: 2 }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <SecurityIcon sx={{ mr: 1, color: '#3f51b5' }} />
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>5. Diagnostic Logging</Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body1" paragraph>
                  For debugging and system monitoring, certain AI-generated output (such as summaries or receipt entries) may be temporarily printed to server logs. These logs:
                </Typography>

                <Box sx={{
                  backgroundColor: '#f5f7ff',
                  p: 2,
                  borderRadius: 1,
                  border: '1px solid #e0e0e0'
                }}>
                  <List dense>
                    <ListItem sx={{ alignItems: 'flex-start' }}>
                      <Box sx={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        backgroundColor: '#3f51b5',
                        mt: '8px',
                        mr: 2
                      }} />
                      <ListItemText 
                        primary="Are not stored permanently or linked to your identity" 
                      />
                    </ListItem>
                    <ListItem sx={{ alignItems: 'flex-start' }}>
                      <Box sx={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        backgroundColor: '#3f51b5',
                        mt: '8px',
                        mr: 2
                      }} />
                      <ListItemText 
                        primary="Are retained for no more than 7 days (if enabled)" 
                      />
                    </ListItem>
                    <ListItem sx={{ alignItems: 'flex-start' }}>
                      <Box sx={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        backgroundColor: '#3f51b5',
                        mt: '8px',
                        mr: 2
                      }} />
                      <ListItemText 
                        primary="Are only accessible to IMAGE-I system administrators under strict access controls" 
                      />
                    </ListItem>
                  </List>
                </Box>

                <Typography variant="body2" sx={{ mt: 2, fontStyle: 'italic', color: '#666' }}>
                  No uploaded documents or personal files are ever logged or reviewed.
                </Typography>
              </AccordionDetails>
            </Accordion>
            
          </Paper>
  
          <Box 
            display="flex" 
            alignItems="center" 
            justifyContent="center"
            gap={2}
            sx={{ width: '100%', maxWidth: 800 }}
          >
            <FormControlLabel
              control={<Checkbox checked={agreeChecked} onChange={(e) => setAgreeChecked(e.target.checked)} />}
              label="I agree to the Privacy Policy"
              sx={{ mb: 2, flexGrow: 1 }}
            />
            <Button
              variant="contained"
              onClick={handleAcceptPrivacy}
              disabled={!agreeChecked || privacyLoading}
              startIcon={privacyLoading ? <CircularProgress size={16} /> : null}
              size="large"
              sx={{ width: 200 }}
            >
              {privacyLoading ? "Submitting…" : "Agree & Continue"}
            </Button>
          </Box>
  
          {privacyError && (
            <Typography color="error" sx={{ mt: 2 }}>{privacyError}</Typography>
          )}
        </Box>
      );
    }
  
  const openFileDialog = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const allowedExt = ["pdf", "xls", "xlsx", "csv", "json"];
    const selectedFiles = Array.from(e.target.files).filter((f) =>
      allowedExt.includes(f.name.split(".").pop().toLowerCase())
    );

    if (selectedFiles.length + files.length > 10) {
      setError("Maximum 10 files allowed. Only the first 10 will be processed.");
      setSnackbarOpen(true);
      setFiles((prev) => [...prev, ...selectedFiles].slice(0, 10));
    } else {
      setFiles((prev) => [...prev, ...selectedFiles]);
    }
    e.target.value = null;
  };

  const removeFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const clearExcelBeforeProcessing = async () => {
    if (fileId) {
      try {
        await axiosInstance.post('https://api.projectivetech.com/user/clear_excel_data/', {
        //await axiosInstance.post('http://localhost:8000/user/clear_excel_data/', {
          file_id: fileId
        });
        console.log("✅ Excel cleared before processing");
      } catch (error) {
        console.error("❌ Failed to clear Excel:", error);
      }
    }
  };

  const handleUpload = async () => {
    if (!files.length) return;
    setLoading(true);
    setUploadProgress(0);
    setShowExcel(false);
    setStatusMessage("");

    const statusMessages = [
      "🧠 Analyzing Documents…",
      "📊 Extracting Incomes",
      "🔍 Reconciling",
      "✅ Completed! Showing Tax Summary…"
    ];
    let currentStep = 0;

    const updateStep = () => {
      if (currentStep < statusMessages.length - 1) {
        setStatusMessage(statusMessages[currentStep]);
        currentStep++;
      }
    };

    // Clear Excel before processing
    await clearExcelBeforeProcessing();

    const formData = new FormData();
    files.forEach((file) => formData.append("files", file));
    formData.append("fileId", fileId);
    formData.append("OrgId", orgId);
    formData.append("userId", userId);
    formData.append("Instructions", instructions);
    formData.append("aisPassword", aisPassword);

    setSubmitted(true);

    try {
      setStatusMessage(statusMessages[currentStep]);
      const interval = setInterval(updateStep, 2000);

      const res = await axiosInstance.post("http://ec2-13-127-114-103.ap-south-1.compute.amazonaws.com:8001/tax_agent/validate_tax_agent/", formData, {
      //const res = await axiosInstance.post("http://localhost:8000/tax_agent/validate_tax_agent/", formData, {
        onUploadProgress: (e) =>
          setUploadProgress(Math.round((e.loaded * 100) / e.total)),
      });

      clearInterval(interval);
      setStatusMessage(statusMessages.at(-1));
      setJsonUrl(res.data.json_url);
      setShowExcel(true);
      setFiles([]);
      setInstructions("");
    } catch (err) {
      console.error("Upload failed", err);
      setError("Upload failed. See console for details.");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleGenerateSummary = async () => {
    try {
      const res = await axiosInstance.post("http://ec2-13-127-114-103.ap-south-1.compute.amazonaws.com:8001/tax_agent/generate_summary_sheet/", {
      //const res = await axiosInstance.post("http://localhost:8000/tax_agent/generate_summary_sheet/", {  
        fileId: fileId,
        org_id: orgId,
        user_id: userId,
      });

      if (res.status === 200 || res.data.status === "success") {
      setStatusMessage("Summary Sheet added!");
      setShowExcel(true);
      setIframeKey(Date.now());  // 👈 Trigger iframe refresh
    } else {
      setStatusMessage("Failed to generate summary.");
    }
  } catch (error) {
    setStatusMessage("Error generating summary.");
    console.error(error);
  }
};

  return (
    <>
      <Box display="flex" height="100vh">
        {/* Left Sidebar */}
        <Box
          width="300px"
          p={2}
          bgcolor="#f5f5f5"
          borderRight="1px solid #ccc"
          display="flex"
          flexDirection="column"
          gap={2}
          sx={{
            maxHeight: "100vh",
            overflowY: "auto",
          }}
        >
          <Box>
            <Typography variant="h6">  Tax Filling Agent</Typography>
            <Typography variant="h6">📄 Upload Documents</Typography>
            <Typography variant="body2" color="textSecondary">
              Banks & Broker P&L, Regulatory PDFs, Excel
            </Typography>
          </Box>

          <Button
            variant="outlined"
            startIcon={<UploadIcon />}
            onClick={openFileDialog}
            fullWidth
            sx={{ mb: 2 }}
          >
            Choose Files
          </Button>

          <input
            ref={fileInputRef}
            type="file"
            multiple
            accept=".pdf,.xls,.xlsx,.json"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />

          <Paper elevation={0} sx={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }}>
            <Box sx={{ p: 1, borderBottom: "1px solid #eee" }}>
              <Typography variant="subtitle2">Selected Files ({files.length}/10)</Typography>
            </Box>

            <Box sx={{ flex: 1, overflow: "auto" }}>
              {files.length > 0 ? (
                <List dense sx={{ p: 0 }}>
                  {files.slice(0,3).map((f, idx) => (
                    <ListItem
                      key={idx}
                      secondaryAction={
                        <IconButton edge="end" size="small" onClick={() => removeFile(idx)}>
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      }
                      sx={{
                        borderBottom: "1px solid #f0f0f0",
                        "&:last-child": { borderBottom: "none" },
                      }}
                    >
                      <ListItemText
                        primary={
                          <Typography variant="body2" noWrap>
                            {f.name}
                          </Typography>
                        }
                        secondary={`${(f.size / 1024).toFixed(1)} KB`}
                        sx={{ my: 0 }}
                      />
                    </ListItem>
                  ))}
                </List>
              ) : (
                <Box sx={{ p: 2, textAlign: "center" }}>
                  <Typography variant="body2" color="textSecondary">
                    No files selected
                  </Typography>
                </Box>
              )}
            </Box>
          </Paper>

          <Button
            variant="contained"
            onClick={handleUpload}
            disabled={loading || files.length === 0}
            fullWidth
            sx={{ mt: "auto" }}
          >
            {loading ? <CircularProgress size={20} /> : "Submit to Tax Agent"}
          </Button>

          <TextField
            type="password"
            label="AIS Password"
            value={aisPassword}
            onChange={(e) => setAisPassword(e.target.value.trim())}
            fullWidth
            size="small"
          />

          <TextField
            label="Instructions"
            multiline
            rows={3}
            fullWidth
            value={instructions}
            onChange={(e) => setInstructions(e.target.value)}
            placeholder="e.g. Consider FY 23-24, exclude foreign income…"
            size="small"
          />

          {submitted && (
            <Button
              variant="outlined"
              onClick={handleGenerateSummary}
              color="secondary"
              fullWidth
              sx={{ mt: 2 }}
            >
              Generate Summary Sheet
            </Button>
            
          )}

          {submitted && (
            <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleHitlReconciliation}
                disabled={loading}
                startIcon={loading ? <CircularProgress size={16} /> : null}
              >
                {loading ? "Reconciliation in Progress..." : "HITL layer3"}
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleHitlSecondLayerReconciliation}
                disabled={loading}
              >
                {loading ? "Reconciliation in Progress..." : "HITL layer2"}
              </Button>
             </Box> 
            
          )}

          {uploadProgress > 0 && uploadProgress < 100 && (
            <Box sx={{ width: "100%" }}>
              <LinearProgress variant="determinate" value={uploadProgress} />
              <Typography variant="caption" display="block" textAlign="center">
                Uploading: {uploadProgress}%
              </Typography>
            </Box>
          )}

          {jsonUrl && (
            <Button
              variant="outlined"
              color="success"
              href={jsonUrl}
              target="_blank"
              download
              fullWidth
              size="small"
            >
              Download JSON
            </Button>
          )}
        </Box>

        <Box flex={1} display="flex" justifyContent="center" alignItems="center">
          {loading && (
            <Box textAlign="center">
              <CircularProgress size={60} />
              <Typography variant="subtitle1" sx={{ mt: 2 }}>
                {statusMessage}
              </Typography>
            </Box>
          )}
          {!loading && showExcel && (
            <iframe
              src={`${baseSharepointUrl}&timestamp=${Date.now()}`}
              title="Tax Summary Excel"
              width="100%"
              height="100%"
              style={{ border: "none" }}
            />
          )}
          {!loading && !showExcel && (
            <Typography color="textSecondary">
              Upload documents to generate Tax Summary.
            </Typography>
          )}
        </Box>
      </Box>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert severity="error" onClose={() => setSnackbarOpen(false)} sx={{ width: "100%" }}>
          {error}
        </Alert>
      </Snackbar>
    </>
  );
}